<template>
    <div class="pc-rental subscribe">
        <div class="container">
            <div v-if="isLoading" class="loading">
                <p>Proccessing</p>
            </div>

            <section v-if="!subscriptionSuccessed && !subscriptionFailed" class="row section-global success-page">
                <h1>Thanks for participating in NZXT BLD's PC Rental Program!</h1>
                <p>Please complete the following form to begin your monthly subscription to NZXT BLD's PC Rental Program.</p>
                <button
                    class="btn btn-green m-y-md"
                    @click="checkout">
                    Start Subscription
                </button>
            </section>

            <section v-if="subscriptionSuccessed" class="row section-global success-page">
                <h1><i class="fa fa-check-circle" /> Success!</h1>
                <p>Your monthly subscription has successfully been processed. Please contact <a href="mailto:rentals@nzxt.com">rentals@nzxt.com</a> for next steps before your PC ships.</p>
            </section>

            <section v-if="subscriptionFailed" class="row section-global success-page">
                <h1><i class="fa fa-exclamation-circle" /> Uh oh! Something went wrong.</h1>
                <p>{{ faillingMessage }}</p>
                <p>If you continue to have issues, please contact <a href="mailto:rentals@nzxt.com">rentals@nzxt.com</a> for further assistance.</p>
            </section>

            <div>
                <vue-stripe-checkout
                    ref="checkoutRef"
                    :image="image"
                    :name="name"
                    :description="description"
                    :currency="currency"
                    :amount="amount"
                    :allow-remember-me="false"
                    @done="done"
                />
            </div>
        </div>
    </div>
</template>

<script>
import Vue from "vue";
import VueStripeCheckout from 'vue-stripe-checkout';
Vue.use(VueStripeCheckout, process.env.MIX_STRIPE_PUBLISHABLE_KEY);

export default {
    name: "PCRentalSubscribe",
    data() {
        return {
            // image: "https://www.letsbld.com/images/logos/logo-nzxt-black.png",
            image: "https://i.imgur.com/poXHnKO.jpg",
            name: "BLD PC Rental",
            description: "Monthly Subscription Payment Method",
            currency: "USD",
            amount: 9900,
            checkoutData: {},
            isLoading: false,
            subscriptionSuccessed: false,
            subscriptionFailed: false,
            faillingMessage: ""
        }
    },
    methods: {
        async checkout () {
            const { token } = await this.$refs.checkoutRef.open();
            this.checkoutData = token;
        },
        done ({ token }) {
            this.checkoutData = token;
            this.createSubscription();
        },
        createSubscription() {
            this.isLoading = true;
            axios.post("/pc-rental", {
                email: this.checkoutData.email,
                token: this.checkoutData.id,
            }).then(() => {
                this.subscriptionSuccessed = true;
            }).catch(error => {
                this.subscriptionFailed = true;
                this.faillingMessage = error;
            }).finally(() => this.isLoading = false)
        }
    }
}
</script>

<style lang="scss">
    @import '~@s/_asset-mixers.scss';
    .pc-rental {

        &.subscribe {
            background-color: #ececec;
            text-align: center;
        }

        .loading {
            background-color: rgba(0,0,0,0.8);
        }

        .fa-exclamation-circle {
            color: #828282;
        }
        .fa-check-circle {
            color: $purple;
        }

        .success-page {
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
            background-color: #ececec;

            h1 {
                font-size: 2em;
                padding: 0 10px;
            }

            p {
                font-size: 20px;
                color: #9b9b9b;
                padding: 0 10px;
            }

            .btn {
                margin-top: 30px;
            }
        }
    }
</style>
